import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import TrafficSignsModel from './TrafficSignsModel'
const BASE = BaseModel.getApiBasePath() + '/api/v1/trafficsigns/trafficsignstates';

export default new class TrafficSignsStatesModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(dateFrom = null, dateTo = null, trafficSignSerialNumber = null) {
    var filter = {
      order: 'createdAt DESC',
      where: {
        and: []
      }
    };
    if (dateFrom && dateTo) {
      filter.where.and.push({ createdAt: { gte: dateFrom } });
      filter.where.and.push({ createdAt: { lte: dateTo } });
    }
    if (trafficSignSerialNumber) {
      filter.where.and.push({ serialNumber: trafficSignSerialNumber });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          TrafficSignsModel.getAll(true)
            .then((ts) => {
              let data = [];
              response.data.map(async (child, idx) => {
                let sign = _.find(ts, { serialNumber: child.serialNumber });
                sign && sign.description
                  ? data.push(Object.assign({}, child, { description: sign.description }))
                  : data.push(Object.assign({}, child, { description: '' }));
              })
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/TrafficSignsStatesModel.js